import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Ean from './ean';
import EanDetail from './ean-detail';
import EanUpdate from './ean-update';
import EanDeleteDialog from './ean-delete-dialog';

const EanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Ean />} />
    <Route path="new" element={<EanUpdate />} />
    <Route path=":id">
      <Route index element={<EanDetail />} />
      <Route path="edit" element={<EanUpdate />} />
      <Route path="delete" element={<EanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EanRoutes;
